import { Observable } from 'rxjs/Observable';
import { CccSocketProvider } from './../../providers/ccc-socket/ccc-socket';
import { CoinsProvider } from './../../providers/coins/coins';
import { ViewController, ModalController, AlertController, ToastController } from 'ionic-angular';
import { Component } from '@angular/core';
import { NavController } from '../../../node_modules/ionic-angular/navigation/nav-controller';
import { UserProvider } from '../../providers/user/user';
import { Report, newReport } from '../../models/Report';
import { ReportsProvider } from '../../providers/reports/reports';

@Component({
    selector: 'add-report',
    templateUrl: 'add-report.html'
})
export class AddReportComponent {
    report: Report;
    editMode: boolean = false;
    newReport: boolean = false;

    isAdmin: Observable<boolean>;
    constructor(
        public viewCtrl: ViewController,
        public navCtrl: NavController,
        public modalCtrl: ModalController,
        public coinCtrl: CoinsProvider,
        public socket: CccSocketProvider,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public reportsCtrl: ReportsProvider,
        public userCtrl: UserProvider
    ) {

        this.isAdmin = this.userCtrl.isAdmin();

        //Set up editor if param passed in
        let report: Report = this.viewCtrl.getNavParams().get('report');
        let isStock = this.viewCtrl.getNavParams().get('isStock') || false;

        if (report) {
            this.report = report;
        }else{
            this.newReport = true;
            this.report = newReport(isStock);
        }
    }

    formatSats(price: number): string {
        const formatter = new Intl.NumberFormat('en-US', { style: 'decimal', maximumFractionDigits: 0 });
        return formatter.format(price);
    }

    removeReport() {
        const alert = this.alertCtrl.create({
            title: `Delete Report`,
            subTitle: `Are you sure you want to delete this Report? You really shouldn't do this unless you've made a mistake.`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.reportsCtrl.removeReport(this.report).then(val => {
                            this.toastCtrl.create({ message: 'Report Deleted', duration: 2000 }).present();
                            this.dismiss();
                        });
                    }
                }
            ]
        })
        alert.present();
    }
    saveReport() {
        const alert = this.alertCtrl.create({
            title: `Save Report`,
            subTitle: `Are you sure you want to save this report?`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.reportsCtrl.editReport(this.report).then(val => {
                            this.toastCtrl.create({ message: 'Report Saved', duration: 2000 }).present();
                            this.dismiss();
                        });
                    }
                }
            ]
        })
        alert.present();
    }

    publishReport() {

        const alert = this.alertCtrl.create({
            title: `Publish Report`,
            subTitle: `Are you sure you are ready to publish this report? Might wanna double check.`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.report.timestamp = (new Date()).getTime();
                        this.reportsCtrl.addReport(this.report).then(val => {
                            this.toastCtrl.create({ message: 'Report Published', duration: 2000 }).present();
                        });
                        this.dismiss();
                    }
                }
            ]
        })
        alert.present();
    }

    getGainClass(gain: number): string {
        if (gain > 0) {
            return 'target';
        } else if (gain < 0) {
            return 'stop';
        } else {
            return '';
        }
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/components/add-report/add-report.ts